import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/campaign/Header";
import Footer from "@/components/campaign/Footer";
import SmoothScroll from "@/components/campaign/SmoothScroll";
import ChatBot from "@/components/campaign/ChatBot";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Issues from "@/pages/Issues";
import Slate from "@/pages/Slate";
import News from "@/pages/News";
import Volunteer from "@/pages/Volunteer";
import Donate from "@/pages/Donate";
import Contact from "@/pages/Contact";
import Vote from "@/pages/Vote";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
};

const Layout = ({ children }) => (
  <div className="flex min-h-screen flex-col bg-canvas">
    <Header />
    <div className="flex-1">{children}</div>
    <Footer />
    <ChatBot />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <SmoothScroll>
        <Toaster
          position="bottom-right"
          toastOptions={{
            classNames: {
              toast: "border border-white/10 bg-parchment/95 backdrop-blur-xl text-ink shadow-2xl",
              title: "font-medium",
            },
          }}
        />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/issues" element={<Issues />} />
            <Route path="/slate" element={<Slate />} />
            <Route path="/news" element={<News />} />
            <Route path="/volunteer" element={<Volunteer />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/vote" element={<Vote />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
